var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFarmerAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "simple",
    clipPath: "url(#clip0_7989_21732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7989_21732",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 77,
    height: 88
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "react-mask-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M59.5905 64.5039V71.0714H61.1057C76.1679 71.0714 88.3783 82.584 88.3783 96.7856V99.9998H12.6211V96.7856C12.6211 82.584 24.8314 71.0714 39.8937 71.0714H41.4088V64.5039C34.8795 61.5794 30.1862 55.6026 29.4033 48.5291C27.1969 48.235 25.4998 46.4473 25.4998 44.2858V39.2859C25.4998 37.1623 27.1379 35.3995 29.2877 35.0594V32.8573C29.2877 21.8117 38.7846 12.8574 50.4997 12.8574C62.2147 12.8574 71.7117 21.8117 71.7117 32.8573V35.0594C73.8615 35.3995 75.4995 37.1623 75.4995 39.2859V44.2858C75.4995 46.4473 73.8025 48.235 71.5961 48.5291C70.8131 55.6026 66.1198 61.5794 59.5905 64.5039Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7989_21732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.5905 64.5039V71.0714H61.1057C76.1679 71.0714 88.3783 82.584 88.3783 96.7856V99.9998H12.6211V96.7856C12.6211 82.584 24.8314 71.0714 39.8937 71.0714H41.4088V64.5039C34.8795 61.5794 30.1862 55.6026 29.4033 48.5291C27.1969 48.235 25.4998 46.4473 25.4998 44.2858V39.2859C25.4998 37.1623 27.1379 35.3995 29.2877 35.0594V32.8573C29.2877 21.8117 38.7846 12.8574 50.4997 12.8574C62.2147 12.8574 71.7117 21.8117 71.7117 32.8573V35.0594C73.8615 35.3995 75.4995 37.1623 75.4995 39.2859V44.2858C75.4995 46.4473 73.8025 48.235 71.5961 48.5291C70.8131 55.6026 66.1198 61.5794 59.5905 64.5039Z",
    fill: "#D0C6AC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skin/\xF0\x9F\x91\xB6\xF0\x9F\x8F\xBD-03-Brown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M112.621 12.8574H12.6211V112.857H112.621V12.8574Z",
    fill: "#FFDBB4"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Neck-Shadow",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7111 41.0723V49.2865C71.7111 60.3321 62.2142 69.2864 50.4991 69.2864C38.7841 69.2864 29.2871 60.3321 29.2871 49.2865V41.0723V46.4294C29.2871 57.475 38.7841 66.4293 50.4991 66.4293C62.2142 66.4293 71.7111 57.475 71.7111 46.4294V41.0723Z",
    fill: "black",
    fillOpacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clothing/Graphic-Shirt"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7989_21732",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 77,
    height: 29
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "react-mask-242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.236 71.1661C77.3026 72.1908 88.3783 83.2774 88.3783 96.803V99.9988H12.6211V96.803C12.6211 83.1542 23.8995 71.989 38.1486 71.1406C38.0506 71.5252 37.9997 71.9192 37.9997 72.3204C37.9997 76.5611 43.681 79.9989 50.6891 79.9989C57.6972 79.9989 63.3784 76.5611 63.3784 72.3204C63.3784 71.928 63.3298 71.5426 63.236 71.1661L63.236 71.1661Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7989_21732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clothes",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.236 71.1661C77.3026 72.1908 88.3783 83.2774 88.3783 96.803V99.9988H12.6211V96.803C12.6211 83.1542 23.8995 71.989 38.1486 71.1406C38.0506 71.5252 37.9997 71.9192 37.9997 72.3204C37.9997 76.5611 43.681 79.9989 50.6891 79.9989C57.6972 79.9989 63.3784 76.5611 63.3784 72.3204C63.3784 71.928 63.3298 71.5426 63.236 71.1661L63.236 71.1661Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/Palette/Gray-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x96\x8DColor",
    d: "M100.499 60.7129H0.5V99.9984H100.499V60.7129Z",
    fill: "#25557C"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Face"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mouth/Default",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mouth",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1953 53.2148C45.1953 55.9763 47.5695 58.2148 50.4983 58.2148C53.4271 58.2148 55.8013 55.9763 55.8013 53.2148",
    fill: "black",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyebrow/Outline/Default",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "I-Browse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Eyebrow",
    d: "M35.2072 35.4143C36.6901 33.4469 40.7555 32.3437 44.2574 33.1545C44.6637 33.2486 45.074 33.0143 45.1738 32.6312C45.2736 32.2481 45.0251 31.8612 44.6188 31.7672C40.5519 30.8255 35.8442 32.103 33.9721 34.5867C33.7298 34.9083 33.8098 35.3542 34.1508 35.5827C34.4919 35.8112 34.9648 35.7358 35.2072 35.4143Z",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Eyebrow_2",
    d: "M65.7909 35.4143C64.308 33.4469 60.2425 32.3437 56.7406 33.1545C56.3343 33.2486 55.924 33.0143 55.8242 32.6312C55.7245 32.2481 55.973 31.8612 56.3793 31.7672C60.4462 30.8255 65.1538 32.103 67.0259 34.5867C67.2683 34.9083 67.1883 35.3542 66.8472 35.5827C66.5062 35.8112 66.0332 35.7358 65.7909 35.4143Z",
    fill: "black",
    fillOpacity: 0.6
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7989_21732",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 100
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "react-mask-323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M100.499 0H0.5V99.9995H100.499V0Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7989_21732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top/Short-Hair/Short-Curly"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7989_21732",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 3,
    width: 47,
    height: 33
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "react-mask-322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8214 18.5798C35.868 18.5604 35.7524 18.5529 35.4745 18.5574C35.8122 18.5568 35.9279 18.5642 35.8214 18.5798ZM32.74 12.9654C32.7392 12.9584 32.7464 13.0193 32.74 12.9654V12.9654ZM73.5156 25.2739C73.4155 24.0893 73.2383 22.9118 72.9404 21.7544C72.7039 20.8345 72.3807 19.9567 71.9985 19.0791C71.7677 18.5488 71.2287 17.8205 71.1653 17.2485C71.1029 16.6851 71.5692 16.0609 71.6687 15.4049C71.7653 14.7665 71.7489 14.0952 71.61 13.4626C71.2944 12.0259 70.2486 10.6898 68.6338 10.3153C68.2733 10.2317 67.5112 10.3347 67.2565 10.1368C66.9644 9.9098 66.761 9.13648 66.4965 8.8263C65.7426 7.94204 64.5667 7.37258 63.3266 7.57112C62.4133 7.71724 62.9377 7.8953 62.2531 7.38855C61.8725 7.10683 61.588 6.67667 61.2183 6.37169C60.6625 5.91354 60.0249 5.52133 59.3653 5.19946C57.6393 4.35731 55.6707 3.74516 53.7426 3.44678C50.2255 2.90243 46.4717 3.37702 43.0626 4.23941C41.3662 4.66853 39.6584 5.21311 38.0828 5.93332C37.4073 6.24211 37.0173 6.49827 36.3129 6.57914C35.2035 6.70652 34.264 6.70016 33.2132 7.14373C29.9797 8.50872 28.5233 11.6754 29.7816 14.7059C30.0347 15.3154 30.3774 15.8506 30.8498 16.3428C31.4258 16.9431 31.6342 16.825 31.1381 17.5152C30.3961 18.5473 29.7706 19.6479 29.2614 20.7908C27.9246 23.7914 27.701 27.1708 27.788 30.3709C27.8185 31.4912 27.8694 32.6252 28.0568 33.7348C28.1377 34.215 28.1604 35.118 28.5425 35.4744C28.7363 35.6551 29.0125 35.7558 29.288 35.6839C29.9355 35.5147 29.7129 35.0642 29.7279 34.646C29.8036 32.5447 29.7014 30.6858 30.2314 28.6099C30.6229 27.0761 31.2754 25.6831 32.121 24.3116C33.1962 22.5673 34.357 21.0354 35.8356 19.5417C36.1833 19.1905 36.2593 19.0416 36.7254 19.0161C37.0785 18.9969 37.5948 19.2248 37.938 19.3037C38.6948 19.4776 39.4529 19.6496 40.2234 19.7666C41.6401 19.982 43.0428 19.9964 44.4722 19.9542C47.2852 19.8712 50.1103 19.6852 52.8377 19.0173C54.649 18.5738 56.2549 17.7777 57.9898 17.1941C58.0208 17.1837 58.4556 16.8916 58.5319 16.9035C58.6383 16.9201 59.2807 17.5556 59.3891 17.6356C60.2322 18.259 61.1569 18.5207 62.0673 19.0034C63.1898 19.5985 62.1027 18.7469 62.7219 19.4886C62.9023 19.7046 62.9947 20.1052 63.1395 20.3499C63.6 21.1294 64.2408 21.8146 65.0072 22.3582C65.7478 22.8835 66.8607 23.1372 67.2384 23.8209C67.5296 24.3483 67.6277 25.0652 67.8627 25.6283C68.4791 27.1051 69.2932 28.4824 70.1073 29.8734C70.7631 30.9944 71.4805 31.9736 71.5534 33.2546C71.5787 33.7005 71.1287 36.3752 72.2249 35.5617C72.3873 35.4412 72.7377 34.0774 72.8097 33.846C73.1018 32.9058 73.2056 31.9242 73.3379 30.9582C73.601 29.0369 73.6874 27.2089 73.5156 25.2739Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7989_21732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Short-Hair",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8214 18.5798C35.868 18.5604 35.7524 18.5529 35.4745 18.5574C35.8122 18.5568 35.9279 18.5642 35.8214 18.5798ZM32.74 12.9654C32.7392 12.9584 32.7464 13.0193 32.74 12.9654V12.9654ZM73.5156 25.2739C73.4155 24.0893 73.2383 22.9118 72.9404 21.7544C72.7039 20.8345 72.3807 19.9567 71.9985 19.0791C71.7677 18.5488 71.2287 17.8205 71.1653 17.2485C71.1029 16.6851 71.5692 16.0609 71.6687 15.4049C71.7653 14.7665 71.7489 14.0952 71.61 13.4626C71.2944 12.0259 70.2486 10.6898 68.6338 10.3153C68.2733 10.2317 67.5112 10.3347 67.2565 10.1368C66.9644 9.9098 66.761 9.13648 66.4965 8.8263C65.7426 7.94204 64.5667 7.37258 63.3266 7.57112C62.4133 7.71724 62.9377 7.8953 62.2531 7.38855C61.8725 7.10683 61.588 6.67667 61.2183 6.37169C60.6625 5.91354 60.0249 5.52133 59.3653 5.19946C57.6393 4.35731 55.6707 3.74516 53.7426 3.44678C50.2255 2.90243 46.4717 3.37702 43.0626 4.23941C41.3662 4.66853 39.6584 5.21311 38.0828 5.93332C37.4073 6.24211 37.0173 6.49827 36.3129 6.57914C35.2035 6.70652 34.264 6.70016 33.2132 7.14373C29.9797 8.50872 28.5233 11.6754 29.7816 14.7059C30.0347 15.3154 30.3774 15.8506 30.8498 16.3428C31.4258 16.9431 31.6342 16.825 31.1381 17.5152C30.3961 18.5473 29.7706 19.6479 29.2614 20.7908C27.9246 23.7914 27.701 27.1708 27.788 30.3709C27.8185 31.4912 27.8694 32.6252 28.0568 33.7348C28.1377 34.215 28.1604 35.118 28.5425 35.4744C28.7363 35.6551 29.0125 35.7558 29.288 35.6839C29.9355 35.5147 29.7129 35.0642 29.7279 34.646C29.8036 32.5447 29.7014 30.6858 30.2314 28.6099C30.6229 27.0761 31.2754 25.6831 32.121 24.3116C33.1962 22.5673 34.357 21.0354 35.8356 19.5417C36.1833 19.1905 36.2593 19.0416 36.7254 19.0161C37.0785 18.9969 37.5948 19.2248 37.938 19.3037C38.6948 19.4776 39.4529 19.6496 40.2234 19.7666C41.6401 19.982 43.0428 19.9964 44.4722 19.9542C47.2852 19.8712 50.1103 19.6852 52.8377 19.0173C54.649 18.5738 56.2549 17.7777 57.9898 17.1941C58.0208 17.1837 58.4556 16.8916 58.5319 16.9035C58.6383 16.9201 59.2807 17.5556 59.3891 17.6356C60.2322 18.259 61.1569 18.5207 62.0673 19.0034C63.1898 19.5985 62.1027 18.7469 62.7219 19.4886C62.9023 19.7046 62.9947 20.1052 63.1395 20.3499C63.6 21.1294 64.2408 21.8146 65.0072 22.3582C65.7478 22.8835 66.8607 23.1372 67.2384 23.8209C67.5296 24.3483 67.6277 25.0652 67.8627 25.6283C68.4791 27.1051 69.2932 28.4824 70.1073 29.8734C70.7631 30.9944 71.4805 31.9736 71.5534 33.2546C71.5787 33.7005 71.1287 36.3752 72.2249 35.5617C72.3873 35.4412 72.7377 34.0774 72.8097 33.846C73.1018 32.9058 73.2056 31.9242 73.3379 30.9582C73.601 29.0369 73.6874 27.2089 73.5156 25.2739Z",
    fill: "#28354B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skin/\xF0\x9F\x91\xB6\xF0\x9F\x8F\xBD-03-Brown_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M100.121 0.00195312H0.121094V100.001H100.121V0.00195312Z",
    fill: "#4A312C"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7989_21732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmerAvatar);
export default __webpack_public_path__ + "static/media/farmerAvatar.6a724249d2fa00b884f2753667165de9.svg";
export { ForwardRef as ReactComponent };